import useTestTag from '../../common/hooks/use-test-tag';
import { mergeStyling } from '../common-functions';

/** Shared with static name/value markup (e.g. a `dt`) that should look like a field label without being one. */
export const fieldLabelStyles = mergeStyling('block font-bold text-sm');

interface FieldLabelProps {
  label: string;
  name?: string;
  /** Extends the base styling. Conflicting utilities win over the base. */
  labelStyles?: string;
  /** For controls a `htmlFor` cannot target (e.g. contenteditable editors): focus the control on label click. */
  onClick?: () => void;
}

export default function FieldLabel({ label, name, labelStyles, onClick }: FieldLabelProps) {
  const tagCreator = useTestTag(label || '');

  return (
    <label
      className={mergeStyling(fieldLabelStyles, labelStyles)}
      htmlFor={name}
      onClick={onClick}
      ref={tagCreator('label')}
    >
      {label}
    </label>
  );
}
